import React from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaInfoCircle } from "react-icons/fa";
import {
  region as userRegion,
  bandAus,
  bandEur,
  bandUK,
  ageBracket,
  cupSize,
  exerciseIntensity,
  cropTopSize,
  braTypeSelection
} from "../../constants/formUtils";
import { Link, useLocation } from "react-router-dom";
import ROUTES from "../../constants/routes";
import { useWizardContextState } from "../../context/wizardContext";
import styles from "./chooseYourBra.module.css";

export const ChooseYourBra = (props) => {
  const location = useLocation();
  const [pathname, setPathname] = React.useState(location.pathname);

  React.useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  const wizardContext = useWizardContextState();
  const {
    region,
    setRegion,
    selectedCropTopSize,
    setSelectedCropTopSize,
    cup,
    setCup,
    band,
    setBand,
    age,
    setAge,
    intensity,
    setIntensity,
    setCurrentStep,
    braType,
    setBraType,
  } = wizardContext;

  return (
    <div className={styles.chooseBraWrap}>
      <h2 className={styles.heading}>{props.wizardHeading}</h2>
      <div className={styles.form}>

        {/* Crop Top Toggle */}
        <div className={styles.toggleButtonContainer}>
          <label className={pathname === "/" ? styles.home : styles.wizard}>
            I usually wear a
          </label>
          <div className={styles.toggleFields}>
              {braTypeSelection.map((r) => (
                <button
                  key={r}
                  className={`${styles.toggleButton} ${r === braType ? styles.active : ""}`}
                  onClick={() => setBraType(r)}
                >
                  {r}
                </button>
              ))}
            </div>
          
        </div>

        {/* Bra Size or Crop Top Size */}
        <fieldset className={styles.fieldset}>
          <legend className={styles.hidden}>Bra or Crop Top Size</legend>
          <div className={styles.fields}>
            {braType===braTypeSelection[0] ? (
              <div className={styles.dropdownField}>
                <label
                  className={pathname === "/" ? styles.home : styles.wizard}
                  htmlFor="cropTopSize"
                >
                  Crop Top Size
                </label>
                <select
                    value={selectedCropTopSize}
                    onChange={(event) => setSelectedCropTopSize(event.target.value)}
                    name="cropTopSize"
                    id="cropTopSize"
                  >
                    {cropTopSize.map((r) => <option>{r}</option>)}
                  </select>
              </div>
            ) : (
              <>
                <div className={styles.dropdownField}>
                  <label
                    className={pathname === "/" ? styles.home : styles.wizard}
                    htmlFor="selectRegion"
                  >
                    Region
                  </label>
                  <select
                    value={region}
                    onChange={(event) => setRegion(event.target.value)}
                    name="selectRegion"
                    id="selectRegion"
                  >
                    {userRegion.map((r) => (
                      <option>{r}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.dropdownField}>
                  <label
                    className={pathname === "/" ? styles.home : styles.wizard}
                    htmlFor="selectBand"
                  >
                    Band
                  </label>
                  <select
                    value={band}
                    onChange={(event) => setBand(Number(event.target.value))}
                    name="selectBand"
                    id="selectBand"
                  >
                    {region === "AU" && bandAus.map((r) => <option key={r}>{r}</option>)}
                    {(region === "UK" || region === "US") && bandUK.map((r) => <option key={r}>{r}</option>)}
                    {region === "EU" && bandEur.map((r) => <option key={r}>{r}</option>)}
                  </select>
                </div>

                <div className={styles.dropdownField}>
                  <label
                    className={pathname === "/" ? styles.home : styles.wizard}
                    htmlFor="selectCup"
                  >
                    Cup
                  </label>
                  <select
                    value={cup}
                    onChange={(event) => setCup(event.target.value)}
                    name="selectCup"
                    id="selectCup"
                  >
                    {cupSize.map((r) => <option key={r}>{r}</option>)}
                  </select>
                </div>
              </>
            )}
          </div>
        </fieldset>

        {/* Age Bracket */}
        <fieldset className={styles.fieldset}>
          <legend className={styles.hidden}>Age Bracket</legend>
          <div className={styles.toggleButtonContainer}>
            <label className={pathname === "/" ? styles.home : styles.wizard}>
              Your age bracket
            </label>
            <div className={styles.toggleFields}>
              {ageBracket.map((r) => (
                <button
                  key={r}
                  className={`${styles.toggleButton} ${r === age ? styles.active : ""}`}
                  onClick={() => setAge(r)}
                >
                  {r}
                </button>
              ))}
            </div>
          </div>
        </fieldset>

        {/* Exercise Intensity */}
        <fieldset className={styles.fieldset}>
          <legend className={styles.hidden}>Exercise Intensity</legend>
          <div className={styles.toggleButtonContainer}>
            <div className={styles.labelWithTooltip}>
              <label className={pathname === "/" ? styles.home : styles.wizard}>
                Breast movement during exercise
              </label>
              <OverlayTrigger
                placement="left"
                trigger={['click','focus']}
                delay={{ show: 150, hide: 400 }}
                overlay={
                  <Tooltip id="intensity-tooltip">
                    <strong>Small:</strong> exercise that results in a small amount of breast movement (e.g., walking, weights, swimming, yoga) <br/><br/>
                    <strong>Moderate:</strong> moderate amount of movement (e.g., pump class, cycling, brisk walking) <br/><br/>
                    <strong>Large:</strong> large amount of movement (e.g., running, jumping, horse-riding)
                  </Tooltip>
                }
                container={document.body}  // render outside parent
                rootClose 
              >
                <FaInfoCircle className={pathname === "/" ? styles.tooltip : styles.tooltipWizard} />
              </OverlayTrigger>
            </div>
            <div className={styles.toggleFields}>
              {exerciseIntensity.map((r) => (
                <button
                  key={r}
                  className={`${styles.toggleButton} ${r === intensity ? styles.active : ""}`}
                  onClick={() => setIntensity(r)}
                >
                  {r}
                </button>
              ))}
            </div>
          </div>
        </fieldset>

        {/* Action Button */}
        {pathname !== "/sportsbra" && (
          <Link
            to={{ pathname: ROUTES.SPORTSBRA }}
          >
            <button
              className={styles.actionButton}
              onClick={() => { setCurrentStep(1); }}
            >
              Find your bra
            </button>
          </Link>
        )}
      </div>

      {props.children && <div className={styles.text}>{props.children}</div>}
    </div>
  );
};

export default ChooseYourBra;
